// src/components/InactivityHandler.js

import  { useEffect, useRef } from "react";
import { handleLogout } from "../utils/utils";

const InactivityHandler = () => {
  const timer = useRef(null);

  useEffect(() => {
    const events = ["mousemove", "keydown", "click"];
    const resetTimer = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        // console.log("User inactive for 1 minute");
        handleLogout();
        window.location.href = "/login"; 
      }, 60 * 60 * 1000); 
      // console.log("Timer reset");
    };

    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer(); 

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return null;
};

export default InactivityHandler;
